import {Controller} from "@hotwired/stimulus"

// Notifies the Flutter WebView host that the share-intent compose page is ready,
// so the native loading spinner can be dismissed. See docs/SHARE_INTENT.md.
export default class extends Controller {
    connect() {
        try {
            if (window.flutter_inappwebview &&
                typeof window.flutter_inappwebview.callHandler === "function") {
                window.flutter_inappwebview.callHandler("shareIntentReady")
            }
        } catch {
            // Non-fatal: the page is still fully functional without the bridge.
        }
    }
}
